"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypeAhead_1 = require("./TypeAhead");
exports.MatchTypeAhead = TypeAhead_1.default;
//# sourceMappingURL=index.js.map